import 'core-js/es/array/includes';
import 'core-js/es/object/assign';
import 'objectFitPolyfill';
import 'promise-polyfill/src/polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import './base/polyfill';
import {offset, triggerEvent} from './base/utils';
import mobile from 'is-mobile';
import Accordion from './components/accordion';
import Archive from './components/archive';
import ArticleSidebar from './components/article-sidebar';
import CentrePlan from './components/centre-plan';
import Cookies from './components/cookies';
import CustomSelect from './components/custom-select';
import Gallery from './components/gallery';
import Modal from './components/modal';
import Orphans from './components/orphans';
import Slider from './components/slider';
import Tabs from './components/tabs';
import TicketAvailability from './components/ticket-availability';
import Timeline from './components/timeline';
import TopBar from './components/top-bar';
import VideoPlayer from './components/video-player';
import VideoPopup from './components/video-popup';
import Program from './components/program';

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            let pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

class App {
    constructor() {
        if (mobile({tablet: true, featureDetect: true})) {
            document.body.classList.add('mobile');
        }

        this.init();

        setTimeout(() => { // deferred script runs before CSSOM
            document.body.classList.remove('preload');
        }, 10);
    }

    init() {
        smoothscroll.polyfill();
        if (typeof lazyLoadInstance !== 'undefined') {
            lazyLoadInstance.update();
        }

        new TopBar(document.querySelector('.header'));
        new Timeline(document.querySelector('.timeline'));
        new TicketAvailability(document.querySelector('.availability'));
        new Cookies();

        [...document.querySelectorAll('.text, .orphans')].forEach(el => new Orphans(el));

        this.initLinks();
        this.initGoToTop();
        this.initAnchors();
        this.initVideo();
        this.initTabs();
        this.initNewsList();
        this.initProcurementList();
        this.initCentrePlan();
        this.initProgram();

        [...document.querySelectorAll('.gallery')].forEach(el => new Gallery(el));
        [...document.querySelectorAll('.accordion')].forEach(el => new Accordion(el));
        [...document.querySelectorAll('select')].forEach(el => new CustomSelect(el));
        [...document.querySelectorAll('.video-banner')].forEach(el => new VideoPopup(el));

        [...document.querySelectorAll('.articles-slider')].forEach(el => this.initArticlesSlider(el));
        [...document.querySelectorAll('.events-slider')].forEach(el => this.initEventsSlider(el));
        [...document.querySelectorAll('.box-list.mobile-slider:not(.small-box-list):not(.program-other-attractions)')].forEach(el => this.initBoxSlider(el));
        [...document.querySelectorAll('.small-box-list.mobile-slider .slider')].forEach(el => this.initSmallBoxSlider(el));
        [...document.querySelectorAll('.support-slider')].forEach(el => this.initSupportSlider(el));
        [...document.querySelectorAll('.support-section.mobile-slider')].forEach(el => this.initSupportSectionSlider(el));
        [...document.querySelectorAll('.case-slider')].forEach(el => this.initCaseSlider(el));
        [...document.querySelectorAll('.recommendations-slider')].forEach(el => this.initRecommendationsSlider(el));
        [...document.querySelectorAll('.program-other-attractions')].forEach(el => this.initOtherAttractionsSlider(el));
        [...document.querySelectorAll('.article-sidebar-container')].forEach(el => this.initArticleSidebar(el));

        let $availabilityBtn = document.querySelector('.js-ticket-availability');
        if ($availabilityBtn) {
            new Modal($availabilityBtn, 'ticket-availability');
        }
    }

    initGoToTop() {
        let $goToTop = document.querySelector('.js-go-to-top');

        if ($goToTop) {
            $goToTop.addEventListener('click', e => {
                e.preventDefault();
                window.scroll({top: 0, left: 0, behavior: 'smooth'});
            });
        }
    }

    static wrapInner(parent, wrapper, attribute, attributevalue) {
        if (typeof wrapper === 'string') {
            wrapper = document.createElement(wrapper);
        }

        let div = parent.appendChild(wrapper);

        if (attribute !== undefined) {
            div.setAttribute(attribute, attributevalue);
        }

        while (parent.firstChild !== wrapper) {
            wrapper.appendChild(parent.firstChild);
        }
    }

    initLinks($context = document) {
        [...$context.querySelectorAll('.text a[href]:not(.btn):not(.file-block), .link')].forEach(el => {
            App.wrapInner(el, 'span', 'class', 'underline');
        });
    }

    initAnchors() {
        [...document.querySelectorAll('.text [href*="#"], .box [href*="#"]')].forEach(el => {
            if (el.hash.length < 2)
                return;

            // noinspection TypeScriptValidateTypes
            let hash = el.hash.split('#')[1],
                id = hash.split(',')[0],
                $target = document.getElementById(id);

            if (!$target)
                return;

            if ($target.classList.contains('modal')) {
                new Modal(el, hash);
            } else {
                el.addEventListener('click', e => {
                    e.preventDefault();

                    let position = offset($target);

                    window.scroll({top: position.top, left: 0, behavior: 'smooth'});
                });
            }
        });
    }

    initArticlesSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            autoHeight: true,
            navigation: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.4,
                    spaceBetween: 60
                },
                1024: {
                    slidesPerView: 2.4,
                    spaceBetween: 60
                }
            }
        });
    }

    initEventsSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            autoHeight: true,
            navigation: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 60
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 60
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 60
                }
            }
        });
    }

    initBoxSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1.3,
            spaceBetween: 0,
            loop: false,
            navigation: false,
            wrapperClass: 'box-list-wrap',
            slideClass: 'box',
            breakpoints: {
                768: {
                    disable: true
                }
            }
        });
    }

    initSmallBoxSlider($slider) {
        new Slider($slider, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: false,
            navigation: true,
            wrapperClass: 'box-list-wrap',
            slideClass: 'box',
            breakpoints: {
                768: {
                    disable: true
                }
            }
        });
    }

    resizeButtons($slides, $buttons) {
        let maxH = [...$buttons].map(el => el.offsetHeight)
            .reduce((acc, curr) => Math.max(acc, curr), 0);

        [...$slides].forEach(el => el.style.paddingBottom = maxH + 'px');
    }

    initSupportSlider($slider) {
        let $slides = $slider.querySelectorAll('.support-slide');
        let $buttons = $slider.querySelectorAll('.support-slide-buttons');

        new Slider($slider, {
            slidesPerView: 1,
            spaceBetween: 60,
            loop: false,
            navigation: true,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            },
            on: {
                init: this.resizeButtons.bind(this, $slides, $buttons),
                resize: this.resizeButtons.bind(this, $slides, $buttons)
            }
        });
    }

    initCaseSlider($slider) {
        new Slider($slider, {
            slidesPerView: 'auto',
            loop: false,
            navigation: true
        });
    }

    initSupportSectionSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1.5,
            spaceBetween: 60,
            loop: false,
            navigation: false,
            centerInsufficientSlides: true,
            wrapperClass: 'support-section-items',
            slideClass: 'support-section-item',
            breakpoints: {
                768: {
                    disable: true
                }
            }
        });
    }

    initRecommendationsSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            autoHeight: false,
            navigation: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.3,
                    spaceBetween: 0
                },
                1024: {
                    slidesPerView: 2.3,
                    spaceBetween: 0
                }
            }
        });
    }

    initOtherAttractionsSlider($slider) {
        new Slider($slider, {
            slidesPerView: 1,
            // spaceBetween: 30,
            loop: false,
            autoHeight: false,
            navigation: true,
            wrapperClass: 'box-list-wrap',
            slideClass: 'box',
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1024: {
                    disable: true
                }
            }
        });
    }

    initArticleSidebar($container) {
        new ArticleSidebar($container);
    }

    initVideo() {
        [...document.querySelectorAll('.video-player')].forEach(el => {
            new VideoPlayer(el);
        });
    }

    initTabs() {
        let $tabs = document.querySelectorAll('.tabs-wrap');

        if ($tabs.length) {
            new Tabs($tabs);
        }
    }

    initNewsList() {
        let $newsList = document.querySelectorAll('.news-list');

        if (!$newsList.length) {
            return;
        }

        new Archive({
            parse: ($item, data) => {
                if (!data.img) {
                    $item.querySelector('.js-img').remove();
                }
            }
        });
    }

    initProcurementList() {
        let $newsList = document.querySelectorAll('.procurement-list'),
            $filter, $month, available, months;

        if (!$newsList.length) {
            return;
        }

        $filter = document.querySelector('.js-archive-filter');
        $month = $filter.querySelector('[name="month"]');
        try {
            available = JSON.parse($filter.dataset['available']);
            months = JSON.parse($filter.dataset['months']);
        } catch (e) {
            console.error('Malformed months array');
        }

        new Archive({
            change: e => {
                if (e.target.name === 'year') {
                    let availableMonthsInYear = available[e.target.value];

                    triggerEvent($month, 'set', months.filter(el => { return availableMonthsInYear.includes(el.value); }));
                }
            }
        });
    }

    initCentrePlan() {
        let $plan = document.querySelectorAll('.centre-plan');

        if (!$plan.length) {
            return;
        }

        [...$plan].forEach($p => new CentrePlan($p));
    }

    initProgram() {
        let isProgram = document.body.classList.contains('program');

        if (!isProgram) {
            return;
        }

        new Program();
    }
}

document.addEventListener('DOMContentLoaded', () => new App());
